<template>
	<!-- 来源信息 -->
	<div class="Minister-top information">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">来源信息</div>
		</div>
		<div class="information_content">
<!--			<div class="information_input" style="margin-bottom:10px;" >-->
<!--				<div class="information_Title">-->
<!--					本地分类-->
<!--				</div>-->
<!--				<div class="input_el input_span">-->
<!--					<div class="newipt">-->
<!--						<el-input-->
<!--								type="text"-->
<!--								class="width85"-->
<!--								placeholder="请输入不含表情符号或HTML格式的纯文本"-->
<!--								v-model="formData.title"-->
<!--						></el-input>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->

			<div class="information_input"" >
				<div class="information_Title">
					来源URL
				</div>
				<div class="input_el input_span">
							<el-row v-for="(item, index) in blue_point" :key="index" style="margin-bottom: 10px">
								<el-col :span="22" style="position: relative;">
									<el-input
											placeholder="可记录采集来源、采购Url等。仅在ERP显示，不会同步到销售平台！"
											v-model="item.value"
											:disabled="system < 5 || isChakan"
											class="width85"
									>
									</el-input>
									<el-button
											style="background: rgb(224,224,224)"
											:disabled="system < 5 || isChakan"
										@click="handleURL(item.value)"
									>访问链接</el-button>
									<el-button
											type="danger"
											:disabled="system < 5 || isChakan"
											@click="deleteItem(item, index)"
											icon="el-icon-delete"
											v-if="index > 0"
									></el-button>
									<el-button
											type="primary"
											:disabled="system < 5 || isChakan"
											@click="addItem(item, index)"
											icon="el-icon-plus"
											v-if="index == 0"
									></el-button>
								</el-col>
							</el-row>

<!--							<span style="color:#F56C6C" v-if="isRequestDone">-->
<!--						<template v-if="blue_point.length">-->
<!--							此链接记录货源链接，可填写1-5条，非必填。-->
<!--						</template>-->
<!--						<template v-else>-->
<!--							暂无货源链接-->
<!--						</template>-->
<!--					</span>-->
				</div>
			</div>
			<div>
				<div class="information_input" >
					<div class="information_Title">
						备注
					</div>
					<div class="input_el input_span">
						<div class="newipt">
							<el-input
									type="textarea"
									:disabled="system < 5 || isChakan"
									class="width85"
									v-model="formData.remark"
									:autosize="{ minRows: 3, maxRows: 4}"
									show-word-limit
							></el-input>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {ajaxPost, Baseurl} from "../../../../api/api/api";
	export default {
		name: 'laiyuanComp',
		props: {
			score: {
				type: Array,
				default() {
					return [0,0,0,0];
				},
			}
		},
		data() {
			return {
				//是否为查看
				isChakan:false,
				system:5,
				blue_point: [{}],
				isRequestDone:false,
				pageType: '',
				sku:'',
				//问号图标的地址
				urlQueImg:require('@/assets/images/wenhao.png'),
				formData:{
					remark:'',
					changkuangao:'0',
				},
			}
		},
		created() {
			this.system = JSON.parse(localStorage.getItem('role')).system
		},
		methods: {
			getHuoyan(){
				this.blue_point = [{
					value: '',
					type: true,
				}]
				this.isRequestDone = false
				ajaxPost(Baseurl + 'productController/getProductSourceLink', {
					sku: this.sku,
					countryMark: '',
				}).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.blue_point = data
								.filter((item) => !!item)
								.map((item) => ({ value: item, type: false }))
						if (this.blue_point.length) {
							this.isRequestDone = true
						}
					}
				})

			},
			handleURL(url) {
				if (!url){
					this.$message('访问链接不能为空！')
					return
				}
				window.open(url)
			},
			// 删除链接
			deleteItem(item, index) {
				this.blue_point.splice(index, 1)
				this.$message({
					type: 'success',
					message: '删除成功!',
				})
			},
			// 添加链接
			addItem() {
				if (this.blue_point.length < 5) {
					const param = {
						value: '',
						type: true,
					}
					this.blue_point.push(param)
				} else {
					this.$message('此链接记录货源链接最多5条字段')
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
</style>
